<template lang="pug">
    tr.px-2(:active="selected" @click="() => { if(clickToVisit && item.owner_for_client_id !== null) { sendEmit('tableSearchAction', item) } }" :class="clickToVisit ? 'click' : ''")
      td.subheading.cell(
        v-for="header, index in headers"
        :key="'action-row-'+header.column+'-'+index"
        :class="header.overflow || '' + (header.type === 'id' ? 'hidden' : '')"
        :style=`header.padding === 'none' ? 'padding: 0;' : '' + header.padding === 'right' ? 'padding-left: 0;' : '' + header.padding === 'left' ? 'padding-right: 0;' : ''`
        :width="header.width"
        ref="cell"
      )
        v-tooltip(
          bottom
          nudge-bottom="15"
          :open-delay="100"
          v-model="isHovering[index]"
          v-if="isHovering[index]"
        )
          div(slot="activator")
          v-layout.align-center(v-if="header.type === 'product_instance'")
            //- v-icon(v-if="!!item.parent_id") forward
            span(:class="item.child || item.parent_id ? 'ml-4' : ''") {{ rcLeaf(item, header.column) }}
          v-layout(
            v-else-if="header.type === 'route' && mapParams(header.to.params, item) && rcLeaf(item, header.column)"
          )
            span {{ rcLeaf(item, header.column) }}
          v-layout.justify-center(
            v-else-if="header.type === 'route'"
          ) -
          span(v-else-if="header.type === 'dateTime'") {{ displayDate(rcLeaf(item, header.column), 'DD MMM YYYY HH:mm') }}
          span(v-else-if="header.type === 'date'") {{ displayDate(rcLeaf(item, header.column)) }}
          span(v-else-if="header.type === 'list'") {{ rcLeaf(item, header.column).join(', ') }}
          span(v-else-if="header.type === 'types_list'") {{ rcLeaf(item, header.column).length ? rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.display_name).join(', ') : '' }}
          span(v-else-if="header.type === 'products_list'") {{ rcLeaf(item, header.column).length ? rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.name).join(', ') : '' }}
          span(v-else-if="header.type === 'bordereau'") {{ categories[item.bordereau.toLowerCase()] }}
          span(v-else-if="header.type === 'id'")
          span(
            v-else-if="!header.type"
            key="cellTypeOther"
          ) {{ rcLeaf(item, header.column) }}
        v-layout.cell-wrapper(
          :style="header.width && header.width.includes('px') ? 'max-width:' + header.width : 'max-width: 100%'"
          :class="{ 'justify-center': header.center }"
          @mouseover="setOpenTooltip(index, true)"
          @mouseleave="setOpenTooltip(index, false)"
        )
          slot(:name="`tableRow-${header.column}`" :header="header" :item="item")
            v-checkbox.row-selection(
              v-if="header.type==='selection'"
              :input-value="selected"
              key="cellTypeSelection"
              hide-details
              :disabled="loading"
              @click.stop="toggleSelected"
              color="primary"
            )
            div(v-else-if="header.type === 'access'")
              v-icon.error--text(v-if="!item.user" large) fiber_manual_record
              v-icon.success--text(v-else-if="item.user.has_password" large) fiber_manual_record
              v-tooltip(
                bottom
                :open-delay="100"
                v-else
              )
                v-icon.warning--text(slot="activator" large) fiber_manual_record
                span En cours
            div(v-else-if="header.type === 'mailState'")
              .error--text(v-if="item.failed" large) Erreur {{ errorCodes[item.error_code] ? ': ' + errorCodes[item.error_code] : '' }}
              span(v-else-if="item.date_read" large) Ouvert le {{ displayDate(item.date_read, 'DD MMM YYYY HH:mm') }}
              .warning--text(v-else large) Non ouvert
            .exists(v-else-if="header.type === 'exists'")
              v-icon.green--text(v-if="rcLeaf(item, header.column)" large) done
              v-icon.red--text(v-else large) clear
            .exists(v-else-if="header.type === 'not exists'")
              v-icon(v-if="rcLeaf(item, header.column)") link
              v-icon(v-else) link_off
            v-avatar(size="50" v-else-if="header.type === 'avatar'" style="filter: grayscale(100%);")
              v-img(alt="avatar" :src="getImageUrl(item, header)" v-if="getImageUrl(item, header)")
              v-img(alt="avatar" :src="item[header.column]" v-else-if="item[header.column]")
              v-icon(size="35" v-else="!item[header.column]" color="grey lighten-1")
                |{{ header.defaultIcon ? header.defaultIcon : 'account_circle' }}
            v-avatar(size="50" v-else-if="header.type === 'tile'" tile)
              v-img(alt="avatar" :src="getImageUrl(item, header)" v-if="getImageUrl(item, header)")
              v-img(alt="avatar" :src="item[header.column]" v-else-if="item[header.column]")
              v-icon(size="35" v-else="!item[header.column]" color="grey lighten-1")
                |{{ header.defaultIcon ? header.defaultIcon : 'account_circle' }}
            v-avatar(size="50" :tile="true" v-else-if="header.type === 'image'")
              v-img(alt="image" :src="item.image_url" v-if="item.image_url")
            v-img(:height="76" :width="100" v-else-if="header.type === 'sheet_image' && item.image_url" alt="image" :src="resizeSheetImage(item.image_url)")
            v-layout.route-link.click(
              v-else-if="header.type === 'route' && mapParams(header.to.params, item) && rcLeaf(item, header.column)"
              @click.stop="$router.push({ name: header.to.name, params: mapParams(header.to.params, item) })"
            )
              span {{ rcLeaf(item, header.column) }}
            v-layout.justify-center(
              v-else-if="header.type === 'route'"
            ) -
            v-layout.py-1.chip-group(
              v-else-if="header.type === 'groups'"
              key="cellTypeGroups"
            )
              span(
                v-if="!rcLeaf(item, header.column).filter((elem, pos, arr) => { return arr.indexOf(elem) == pos; }).filter(x => !!x).length"
                style="width: 100%; display: flex; justify-content: center;"
              ) -
              v-chip(
                v-for="product in rcLeaf(item, header.column).filter((elem, pos, arr) => { return arr.indexOf(elem) == pos; }).filter(x => !!x)"
                :key="'row-groups-'+product"
                small
                color="grey lighten-1"
              )
                | {{product}}
            v-layout.py-1.chip-group(
              v-else-if="header.type === 'products_list'"
              key="cellTypeGroups"
            )
              span(
                v-if="!rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.name).length"
                style="width: 100%; display: flex; justify-content: center;"
              ) -
              v-chip(
                v-for="product in rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.name)"
                :key="'row-groups-'+product"
                small
                color="grey lighten-1"
              )
                | {{product}}
            v-layout.py-1.chip-group(
              v-else-if="header.type === 'product_groups' && item.user && item.user.has_password"
              key="cellTypeGroups"
            )
              span(
                v-if="!rcLeaf(item, header.column).filter((elem, pos, arr) => { return arr.indexOf(elem) == pos; }).filter(x => !!x).length"
                style="width: 100%; display: flex; justify-content: center;"
              ) -
              v-chip(
                v-for="product in rcLeaf(item, header.column).filter((elem, pos, arr) => { return arr.indexOf(elem) == pos; }).filter(x => !!x)"
                :key="'row-groups-'+product"
                small
                color="grey lighten-1"
              )
                | {{product}}
            v-layout.py-1.chip-group(
              v-else-if="header.type === 'product_groups'"
              key="cellTypeGroups"
            )
              span(
                style="width: 100%; display: flex; justify-content: center;"
              ) -
            .actions-btns(v-else-if="header.type==='actions'")
              div(v-for="button in header.buttons" :key="button.eventKey")
                div(v-if="!!button.condition && button.condition(item)")
                  v-tooltip(bottom v-if="button.tooltip")
                    v-btn(
                      slot="activator"
                      flat
                      icon
                      @click.stop="sendEmit(button.eventKey, item)"
                    )
                      v-icon {{ button.icon }}
                    v-layout
                      span.text-xs-center {{ button.tooltip }}
                  v-btn(
                    v-else
                    slot="activator"
                    flat
                    icon
                    @click.stop="sendEmit(button.eventKey, item)"
                  ) :class="{ 'pa-0': header.type === 'id' }"
                    v-icon {{ button.icon }}
            v-layout.align-center(v-else-if="header.type === 'product_instance'")
              //- v-icon(v-if="!!item.parent_id") forward
              span(
                :class="item.child ? 'ml-4' : ''"
                :style="rcLeaf(item, header.column) ? '' : 'width: 100%; display: flex; justify-content: center;'"
              ) 
                span {{ rcLeaf(item, header.column) ? rcLeaf(item, header.column) : '-' }}
                span.pl-2.underline.click(v-if="item.sheet_id" @click="$router.push({ name: 'sit_sheets_detail', params: { sheetId: item.sheet_id } })")
                  |({{ item.sheet_name }})
            span(
              v-else-if="header.type === 'dateTime'"
              :style="rcLeaf(item, header.column) ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ rcLeaf(item, header.column) ? displayDate(rcLeaf(item, header.column), 'DD MMM YYYY HH:mm') : '-' }}
            span(
              v-else-if="header.type === 'date'"
              :style="rcLeaf(item, header.column) ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ rcLeaf(item, header.column) ? displayDate(rcLeaf(item, header.column)) : '-' }}
            span(
              v-else-if="header.type === 'list'"
              :style="rcLeaf(item, header.column).length ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ rcLeaf(item, header.column).length ? rcLeaf(item, header.column).join(', ') : '-' }}
            v-layout.py-1.chip-group(
              v-else-if="header.type === 'types_list'"
              :style="rcLeaf(item, header.column).length ? '' : 'width: 100%; display: flex; justify-content: center;'"
            )
              span(
                v-if="!rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.display_name).filter(it => !!it).length"
                style="width: 100%; display: flex; justify-content: center;"
              ) -
              v-chip(
                v-for="type in rcLeaf(item, header.column).map(it => header.filters.values.find(x => x.id === it) || {}).map(it => it.display_name).filter(it => !!it)"
                :key="'row-groups-'+type"
                small
                color="grey lighten-1"
              )
                | {{ type }}
            span(
              v-else-if="header.type === 'bordereau'"
              :style="categories[item.bordereau.toLowerCase()] ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ categories[item.bordereau.toLowerCase()] ? categories[item.bordereau.toLowerCase()] : '-' }}
            span(
              v-else-if="header.type === 'capitalize'"
              :style="rcLeaf(item, header.column).length ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ rcLeaf(item, header.column) ? capitalize(rcLeaf(item, header.column)) : '-' }}
            span(v-else-if="header.type === 'id'")
            span(
              v-else
              key="cellTypeOther"
              :style="rcLeaf(item, header.column) ? '' : 'width: 100%; display: flex; justify-content: center;'"
            ) {{ rcLeaf(item, header.column) ? rcLeaf(item, header.column) : '-' }}
</template>

<script>
import rcLeaf from '@/mixins/rcLeaf';

export default {
  name: 'RcTableRow',
  mixins: [
    rcLeaf,
  ],
  data() {
    return {
      mutableSelected: this.selected,
      isLoaded: {},
      isHovering: this.headers.map(it => false),
      errorCodes: {
        blocked: 'Blocké',
        spam: 'Spam',
        bounce: 'Renvoyé',
      },
    };
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    loading: Boolean,
    translateHeaders: {
      type: Boolean,
      default: false,
    },
    clickToVisit: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    categories() {
      return this.$store.state.app.sheetCategories;
    },
  },
  methods: {
    getImageUrl(item, header) {
      if (header.partnerType && item.has_image) {
        switch (header.partnerType) {
          case 'client':
            return `/v2/erp/ambassador/clients/${item.id}/image/small?t=${item.write_date}`;
          case 'contact':
            return `/v2/erp/ambassador/contacts/${item.id}/image/small?t=${item.write_date}`;
          case 'user':
            return `/v2/erp/users/${item.id}/image/small?t=${item.write_date}`;
          default:
            return null;
        }
      }
      return null;
    },
    setOpenTooltip(index, value) {
      if (!value || this.checkOverflow(this.$refs.cell[index])) {
        this.$set(this.isHovering, index, value)
      }
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    checkOverflow(el) {
      if (!el) return false;
      const spans = el.getElementsByTagName('span');
      const span = spans[spans.length - 1];
      if (!span) return false;
      return span && span.clientWidth < span.scrollWidth;
    },
    resizeSheetImage(url) {
      return `http://api.tourism-system.com/resize/crop/200/150/80/${btoa(unescape(encodeURIComponent(url))).replace('/', '_')}/image.jpg`
    },
    loadImage(id) {
      this.$set(this.isLoaded, id, true);
    },
    toggleSelected() {
      if (!this.loading) {
        this.$emit('toggleSelected', this.selected);
      }
    },
    sendEmit(emitName, value) {
      this.$emit('sendEmit', { emitName, value });
    },
    mapParams(params, item) {
      return Object.entries(params)
        .map(it => [it[0], this.rcLeaf(item, it[1])])
        .reduce((it, [k, v]) => ({ ...it, [k]: v }), {});
    },
    displayDate(date, format = 'LL') {
      const displayDate = this.$moment(date).utcOffset(0).locale('fr').format(format);
      return displayDate === 'Invalid date' ? null : displayDate;
    },
  },
};
</script>

<style lang="scss">
.v-input--checkbox {
  .v-input__slot {
    display: flex;
    justify-content: center;
    margin: 0;
  }
}
.cell:not(.newline) {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  .cell-wrapper {
    span:not(.v-chip) {
      word-break: break-all;
      text-overflow: ellipsis;
      overflow-x: hidden;
    }
    .chip-group {
      &:hover {
        flex-wrap: wrap;
      }
    }
  }
}
td.hidden {
  display: none;
}
.route-link {
  span {
    &:hover {
      color: #1976d2;
      border-bottom: 1px solid #1976d2;
    }
    border-bottom: 1px solid black;
  }
}
.actions-btns,
.exists {
  display: flex;
  justify-content: center;
}
</style>
